<template>
  <el-dialog :visible.sync="innerVisible" width="800px" class="app-main-inner" :close-on-click-modal="false" @close="cancel">
    <div slot="title" class="header-title">
      <span style="line-height: 24px;font-size: 15px;font-weight: bold;color: #333333;">{{ $t('CargoMsg.Cargo_Tips') }}</span>
      <span v-if="reminderFlag === 0" style="color: #ffaa00;padding-left: 10px;padding-right: 6px;font-size: 15px;font-weight: bold;">{{ $t('CargoMsg.BUSINESS_CAN_ARCHIVED') }}</span>
      <span v-else-if="reminderFlag === 1" style="color: #ffaa00;padding-left: 10px;padding-right: 6px;font-size: 15px;font-weight: bold;">{{ $t('CargoMsg.NOT_FULLY_COMPLETED') }}</span>
      <span v-else-if="reminderFlag === 2" style="color: #ffaa00;padding-left: 10px;padding-right: 6px;font-size: 15px;font-weight: bold;">{{ $t('CargoMsg.NON_FILEABLE_BUSINESS') }}</span>
    </div>
    <div class="section grid-wrapper">
      <cargo-ag-grid
        config-module="190912"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :grid-params.sync="gridParams"
        :row-data="data"
      />
    </div>
    <div slot="footer">
      <el-button no="1" type="primary" size="mini" :disabled="reminderFlag === 2" @click="confirm">{{ $t('CargoMsg.Cargo_ConfirmR') }}</el-button>
      <el-button no="2" size="mini" @click="cancel">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
    </div>
  </el-dialog>

</template>

<script>

import CargoDialog from '@/components/Cargo/Common/CargoDialog'
import ColumnUtils from '@/utils/ColumnUtils'

export default {
  name: 'PigeonholeDialog',
  components: { CargoDialog },
  props: {
    visible: { type: Boolean, required: true }, // 是否隐藏
    data: { type: Array, required: true, default: () => [] }
  },
  data() {
    return {
      innerVisible: this.visible,
      gridOptions: {
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        pagination: false
      },
      gridParams: {},
      gridApi: {},
      columnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_BusinessNo'),
          field: 'jobNo',
          width: 130,
          colId: 'jobNo'
        },
        {
          headerName: this.$t('CargoMsg.Financial_Review_Status'),
          field: 'financialReviewStatus',
          width: 150,
          colId: 'financialReviewStatus',
          cellRenderer: (params) => {
            return ColumnUtils.voucherStateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Other_Reminders'),
          field: 'otherReminders',
          width: 360,
          colId: 'otherReminders'
        },
        {
          headerName: this.$t('CargoMsg.Can_Be_Archived'),
          field: 'isCanPigeonhole',
          width: 130,
          colId: 'isCanPigeonhole',
          cellRenderer: (params) => {
            return ColumnUtils.archiveableLabelFunc(params.value)
          }
        }
      ],
      reminderFlag: 0
    }
  },
  computed: {

  },
  created() {
    this.reminderFlag = this.reminderJudgment()
  },
  methods: {
    cancel() {
      this.$emit('closeCallback')
      this.$emit('update:visible', false)
    },
    confirm() {
      this.$emit('confirm', this.data)
    },
    // 提醒判断 0 业务可归档 1 存在业务未完全完成 2存在不可归档业务
    reminderJudgment() {
      let flag = false
      for (const item of this.data) {
        if (item.isCanPigeonhole === 0) {
          return 2
        }
        if (item.otherReminders && item.otherReminders.length > 0) {
          flag = true
        }
      }
      if (flag) return 1
      return 0
    }
  }
}
</script>
